import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const testimonials = [{
  name: 'Flor',
  image: 'https://cdn.magicpatterns.com/uploads/r6XtV1RFNsACr9yhHNZCgk/BB_GLOW_1.webp',
  message: 'Los cambios que estoy haciendo en mis clientas Tami son IMPRESIONANTES! todas me estan re-agendando 😍 GRACIAS!!!',
  response: 'Gracias por compartirme esto hermosa!!!! ahora si que esa cuenta no va a parar de subir!!!'
}, {
  name: 'Paula',
  image: 'https://cdn.magicpatterns.com/uploads/tb1PhH9LPZGCzwgL8XEZPq/BB_GLOW_2.webp',
  message: 'Tamii te mando foto de mis resultados!! realmente estoy maravillada con todo el contenido!!!',
  response: 'Que hermosos labiooos!!!! te convertiste en una profesional en menos de una semana!! 😍'
}, {
  name: 'Micaela',
  image: 'https://cdn.magicpatterns.com/uploads/8MzqUJRfZNVnLqLdsXdBkY/BB_GLOW_4.webp',
  message: 'Hola Tami!! Asi quedo uno de mis trabajos despues de leer y verme el material completo! la verdad que mejoro muchisimo a lo que hacia antes!!',
  response: 'Mica, wow, te quedo expectacular!! aplicaste muy rapido'
}, {
  name: 'Franchesca',
  image: 'https://cdn.magicpatterns.com/uploads/x5gVXTEy6e9kD9h4iHF2Da/BB_GLOW_5.webp',
  message: 'Tamii por aca te paso mi trabajo! me colgue en enviarte ayer! avisame que te parece! ❤️',
  response: 'Fran! te quedo HERMOSO!😍 Ahora te envio el formulario para el certificado!'
}, {
  name: 'Susana',
  image: 'https://cdn.magicpatterns.com/uploads/1UviPSnFxyhovLb6c9JNGh/BB_GLOW_6.webp',
  message: 'Hola hermosa! mira que lindo quedo😍\n\nSe lo hice a mi hermana para practicar y quedo muy bien! ahora me voy a animar a tomar clientas! Gracias Tami!!!',
  response: 'Facil y Rapido Susana! te felicito y me alegra mucho tu crecimiento!!'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [imageLoaded, setImageLoaded] = useState<{
    [key: number]: boolean;
  }>({});
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const startAutoplay = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
    }, 5000);
  };
  const stopAutoplay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };
  useEffect(() => {
    if (!isPaused) {
      startAutoplay();
    } else {
      stopAutoplay();
    }
    return () => stopAutoplay();
  }, [isPaused]);
  // Preload all images
  useEffect(() => {
    testimonials.forEach((testimonial, index) => {
      const img = new Image();
      img.src = testimonial.image;
      img.onload = () => {
        setImageLoaded(prev => ({
          ...prev,
          [index]: true
        }));
      };
    });
  }, []);
  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);
  const handleTouchStart = () => setIsPaused(true);
  const handleTouchEnd = () => setIsPaused(false);
  return <section id="testimonios" className="py-12 px-4 bg-white" data-id="element-370">
      <div className="max-w-5xl mx-auto" data-id="element-371">
        <div className="text-center mb-10 space-y-3" data-id="element-372">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#3D3028]" data-id="element-373">
            Lo que dicen nuestras alumnas
          </h2>
          <p className="text-sm md:text-base text-[#3D3028]/70 max-w-2xl mx-auto" data-id="element-374">
            Resultados reales de estudiantes que dominaron la técnica en menos
            de 7 días
          </p>
        </div>

        <div className="relative max-w-2xl mx-auto" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-375">
          {/* Carousel Container */}
          <div className="relative overflow-hidden rounded-2xl bg-[#FAF8F4] border border-[#D4C4B0]/20 shadow-lg" data-id="element-376">
            <AnimatePresence mode="wait" data-id="element-377">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 100
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -100
            }} transition={{
              duration: 0.5
            }} className="p-6 md:p-8" data-id="element-378">
                {/* Testimonial Image with fixed aspect ratio */}
                <div className="relative rounded-xl overflow-hidden mb-6 shadow-md bg-[#FAF8F4]" data-id="element-379">
                  <div className="relative w-full" style={{
                  paddingBottom: '75%'
                }} data-id="element-380">
                    {!imageLoaded[currentIndex] && <div className="absolute inset-0 flex items-center justify-center" data-id="element-381">
                        <div className="w-8 h-8 border-3 border-[#E5A5A0] border-t-transparent rounded-full animate-spin" data-id="element-382"></div>
                      </div>}
                    <img src={testimonials[currentIndex].image} alt={`Testimonio de ${testimonials[currentIndex].name}`} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${imageLoaded[currentIndex] ? 'opacity-100' : 'opacity-0'}`} loading="eager" onLoad={() => setImageLoaded(prev => ({
                    ...prev,
                    [currentIndex]: true
                  }))} data-id="element-383" />
                  </div>
                </div>

                {/* Testimonial Content */}
                <div className="space-y-4" data-id="element-384">
                  {/* Student Message */}
                  <div className="bg-white rounded-xl p-4 shadow-sm border-l-4 border-[#E5A5A0]" data-id="element-385">
                    <p className="text-[#3D3028] font-semibold text-sm mb-1" data-id="element-386">
                      {testimonials[currentIndex].name}
                    </p>
                    <p className="text-[#3D3028]/80 text-sm leading-relaxed whitespace-pre-line" data-id="element-387">
                      {testimonials[currentIndex].message}
                    </p>
                  </div>

                  {/* Instructor Response */}
                  <div className="bg-[#E5A5A0]/10 rounded-xl p-4 shadow-sm border-l-4 border-[#D4AF7A]" data-id="element-388">
                    <p className="text-[#3D3028] font-semibold text-sm mb-1" data-id="element-389">
                      Tami (Instructora)
                    </p>
                    <p className="text-[#3D3028]/80 text-sm leading-relaxed" data-id="element-390">
                      {testimonials[currentIndex].response}
                    </p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Navigation Dots */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-391">
            {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-8 bg-[#E5A5A0]' : 'w-2 bg-[#D4C4B0]/40 hover:bg-[#D4C4B0]'}`} aria-label={`Ver testimonio ${index + 1}`} data-id="element-392" />)}
          </div>

          {/* Pause Indicator */}
          {isPaused && <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="absolute top-4 right-4 bg-[#3D3028]/80 text-white px-3 py-1 rounded-full text-xs font-medium" data-id="element-393">
              Pausado
            </motion.div>}
        </div>

        {/* Additional Trust Element */}
        <div className="text-center mt-8" data-id="element-394">
          <p className="text-[#3D3028]/60 text-sm" data-id="element-395">
            Más de 2,000 alumnas han transformado su carrera con este método
          </p>
        </div>
      </div>
    </section>;
}